import React, { useEffect } from 'react';
import { ArrowRight, Cog, GitBranch, Code, Server, BarChart } from 'lucide-react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useLocation } from 'react-router-dom';
import hero1 from '../../assets/cloudService.png'

const CloudMigrationServices = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div>
             <Header />
    <div className="bg-black  min-h-screen text-white">
      {/* Header/Nav */}

      {/* Hero Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-5xl">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
              <div className="p-4 inline-block bg-blue-500/20 rounded-xl mb-4">
                <Cog className="w-12 h-12 text-blue-500" />
              </div>
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
                Cloud <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">Migration</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8">
              Flat-fee automated cloud migration services
              </p>
              <p className="text-gray-300 mb-8">
              Move to the cloud up to 5x faster and achieve rapid compliance with built-in security & compliance controls. 
              </p>
              <Link to='/contact'> 
              <button className="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg transition-colors flex items-center">
                Get Started <ArrowRight className="ml-2 w-5 h-5" /> 
              </button>
              </Link>
            </div>
            <div className="md:w-1/2">
              <div className=" p-6 ">
                <img src={hero1} alt="Cloud Migration " className="rounded-lg w-full" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4 bg-black/50">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold mb-12 text-center">Key Benefits</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Accelerate your Cloud Migration by 5x</h3>
              <p className="text-gray-300">Streamline your cloud migration with cutting-edge automation and Infrastructure-as-Code (IaC) techniques. Our comprehensive services minimize manual intervention and errors, leading to a more efficient migration process with reduced downtime and minimal disruption to your business operations.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">End-to-End Cloud Migration Solutions</h3>
              <p className="text-gray-300">Manage your entire cloud migration journey, from initial strategic planning to final implementation. Our tailored approach ensures your infrastructure is optimized for security and performance, while our hands-on support guarantees a smooth and successful transition to the cloud.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Post Cloud Migration Support</h3>
              <p className="text-gray-300">Extend beyond migration, offering a comprehensive suite for cloud management, including compliance, security, app deployment, and CI/CD pipeline integration. Our intuitive platform, combined with expert support, enables efficient cloud optimization and customized infrastructure management for your needs.</p>
            </div>
            <div className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-blue-500 transition-all duration-300">
              <div className="text-blue-500 mb-4">
                <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Enhanced Team Collaboration</h3>
              <p className="text-gray-300">Standardize processes and workflows to improve communication and collaboration between development and operations teams.</p>
            </div>
          </div>
        </div>
      </section>

     

      {/* CTA Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 md:p-12">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold mb-4">Ready to migrate your cloud?</h2>
              <p className="text-blue-100 max-w-2xl mx-auto">
                Let our experts help you migrate your cloud.
              </p>
            </div>
            <div className="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0 md:space-x-6">
              <button className="w-full md:w-auto bg-white text-blue-600 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg transition-colors">
                Schedule a Consultation
              </button>
            </div>
          </div>
        </div>
      </section>
     </div>
     <Footer />
     </div>
  )
}
export {CloudMigrationServices};